import { PATCH } from "../APiHelper/API"

export const setGamePosponed = (data, onSuccess, onError) => {
    // const data = {
    //     fixture_id: fixture_id,
    //     league_id: league_id,
    //     postponed: postponed,
    // }
    PATCH(`/api/v1/games/postponed`, data, onSuccess, onError)
}